<template>
  <label class="container-checkbox" :class="{ error: hasError }">
    <slot></slot>
    <input v-model="checked" type="checkbox" />
    <span class="checkmark"></span>

    <div v-if="hasError && errorMessage" class="error-message">
      {{ errorMessage }}
    </div>
  </label>
</template>

<script>
export default {
  name: 'aeb-checkbox',
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    errorMessage: {
      type: String,
      default: '',
    },
    onCheck: {
      type: Function,
      default: null,
    },
    hasError: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:modelValue'],
  computed: {
    checked: {
      get() {
        return this.modelValue;
      },
      set(newValue) {
        this.$emit('update:modelValue', newValue);
        if (this.onCheck) {
          this.onCheck(newValue);
        }
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.container-checkbox {
  display: block;
  min-height: 24px;
  align-content: center;
  position: relative;
  padding-left: 36px;
  margin-bottom: 16px;
  margin-top: 16px;
  cursor: pointer;
  font-size: 16px;
  line-height: 20px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.container-checkbox input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

.container-checkbox .checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 20px;
  width: 20px;
  border-radius: 4px;
  transition: 0.5s;
  z-index: 4;
  border: 2px solid $gray-primary;
  box-sizing: content-box;
}

.container-checkbox:hover input ~ .checkmark {
  background-color: $lightblue;
}

.container-checkbox input:checked ~ .checkmark {
  background-color: $blue;
  border-color: $blue;
}

.container-checkbox .checkmark:after {
  content: '';
  position: absolute;
  display: none;
}

.container-checkbox input:checked ~ .checkmark:after {
  display: block;
}

.container-checkbox .checkmark:after {
  width: 20px;
  height: 20px;
  background-image: url(../assets/icon-check.svg);
  background-position: center;
  background-repeat: no-repeat;
}

.error {
  .checkmark {
    border-color: #ff3055;
  }
}

.error-message {
  font-size: 14px;
  line-height: 18px;
  margin-top: 8px;
  color: #ff3055;
}
</style>
